import PropTypes from 'prop-types';
import Button from 'components/ui-components/Button';

const ContentPanel = ({ cta, children, className }) => (
  <div className={`cef-ui-content-panel${className ? ` ${className}` : ''}`}>
    {children && children}

    {cta && (
      <div className="cef-ui-content-panel__cta">
        <Button
          className="cef-btn--as-ul-link"
          type="button"
          handleClick={cta.onClick}>
          {cta.title}
        </Button>
      </div>
    )}
  </div>
);

ContentPanel.propTypes = {
  cta: PropTypes.shape({
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  }),
  children: PropTypes.node.isRequired,
};

export default ContentPanel;
